export default "__VITE_ASSET__BnQFWcXj__"